import './StatCard.css';

interface StatCardProps {
  title: string;
  value: string | number;
  unit?: string;
  change?: number; // 증감률 (%)
  icon?: string;
  isLoading?: boolean;
}

export default function StatCard({
  title,
  value,
  unit,
  change,
  icon,
  isLoading = false,
}: StatCardProps) {
  const isPositive = change !== undefined && change > 0;
  const isNegative = change !== undefined && change < 0;

  return (
    <div className="stat-card card">
      <div className="stat-card__header">
        <span className="stat-card__title">{title}</span>
        {icon && <span className="stat-card__icon">{icon}</span>}
      </div>

      {isLoading ? (
        <div className="stat-card__skeleton" />
      ) : (
        <div className="stat-card__body">
          <span className="stat-card__value">
            {typeof value === 'number' ? value.toLocaleString('ko-KR') : value}
          </span>
          {unit && <span className="stat-card__unit">{unit}</span>}
        </div>
      )}

      {!isLoading && change !== undefined && (
        <div
          className={`stat-card__change ${
            isPositive ? 'positive' : isNegative ? 'negative' : 'neutral'
          }`}
        >
          <span className="stat-card__change-arrow">
            {isPositive ? '▲' : isNegative ? '▼' : '─'}
          </span>
          <span>
            전일 대비 {Math.abs(change).toFixed(1)}%
          </span>
        </div>
      )}
    </div>
  );
}
